// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seo-content__text[data-v-fdf2d424]{max-width:1150px}.seo-content__mayor[data-v-fdf2d424]{line-height:1.3em}.seo-content__greeting[data-v-fdf2d424]{position:relative}.seo-content__greeting-logo[data-v-fdf2d424]{position:absolute;right:0;top:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
